import { getUserInfoByCode } from "@/axios/auth";
export default {
  state: {
    unionId: localStorage.getItem("KTBJ_unionId") || "",
  },
  getters: {},
  mutations: {
    commitSetUnionId(state, data) {
      return (state.unionId = data);
    },
  },
  actions: {
    getUnionId({ commit }, { meta }) {
      return getUserInfoByCode(meta)
        .then((res) => {
          const unionId = res.data ? res.data.unionId : '';
          commit("commitSetUnionId", unionId);
          localStorage.setItem("KTBJ_unionId", unionId);
          return res;
        });
    },
  },
};
